import { render } from "./Error404.vue?vue&type=template&id=b14eddb2&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=b14eddb2&lang=scss&scoped=true"
import "./Error404.vue?vue&type=style&index=1&id=b14eddb2&scoped=true&lang=scss"
import "./Error404.vue?vue&type=style&index=2&id=b14eddb2&scoped=true&lang=scss"
import "./Error404.vue?vue&type=style&index=3&id=b14eddb2&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14eddb2"]])

export default __exports__